import { getListOfGatewayAndPrice } from "../types/gateway_and_price_list_types";

const initState = {
  data: [],
  count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function gatewayAndPriceListReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        count: action.payload.count,
        error: null,
      };
    case getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
